export enum TalktalkResultCode {
  SUCCESS = '00',
  PARSING_ERROR = '01',
  MISSING_PARAMETER = '02',
  INTERNAL_ERROR = '03',
  WRONG_ARGUMENTS = '04',
  ALREADY_FRIEND = '05',
  NOT_EXISTS_USER = '06',
  NO_FRIEND = '07',
  PARTNER_NOT_AVAILABLE = '08',
  TOO_MANY_PARTNERS = '09',
  PARTNERS_IS_EMPTY = '10',
  UNKNOWN_ERROR = '99',
}

export enum TalktalkLayerType {
  ENROLL_TALKTALK_ACCOUNT = 'ENROLL_TALKTALK',
  SUGGEST_TALKTALK_ENROLL = 'SUGGEST_TALKTALK_ENROLL',
  REMOVE_TALKTALK_ACCOUNT = 'REMOVE_TALKTALK_ACCOUNT',
}

export enum TalktalkButtonType {
  BRANCH = 'branch',
  STORE = 'store',
  PRODUCT = 'product',
  DESIGNER = 'designer',
  FASHION_BRAND = 'fashionBrand',
  RELATED_PRODUCT_STORE = 'related_product_store',
}
